var map = {
	"./admin-icon.png": "e1c3",
	"./admin-icon.svg": "52bf",
	"./arrow-user.svg": "d5b4",
	"./dashboard-icon.png": "90ca",
	"./dashboard.svg": "b711",
	"./events.svg": "7986",
	"./heart.svg": "c932",
	"./indication.svg": "6028",
	"./logout.svg": "90a3",
	"./menu-icon.png": "2d9e",
	"./order.svg": "dc4b",
	"./shop.png": "4748",
	"./shop.svg": "c7ef",
	"./statement.svg": "205d",
	"./statistics.svg": "d88c",
	"./suggestion.svg": "f33d",
	"./user.svg": "34d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f5fb";